import React from 'react';
import { UserInfo } from '@/service/user/type.d';
import { AppDispatch } from '@/stores/store';
import { APP_LIST_TYPE } from '@/service/apps/type/appList.d';

export type GlobalDataType = {
  userInfo: UserInfo;
  appInfo?: APP_LIST_TYPE;
  dispatch?: AppDispatch;
  update: () => void;
  t?: any;
  awsConfig?: Record<string, any>;
};

export const GlobalData = React.createContext<GlobalDataType>({
  userInfo: {
    currentTeamId: '0',
  },
  update: () => {
    return null;
  },
});
